/**
 * Centralized role constants for frontend/backend alignment
 * Ensures consistency across authentication, routing, and UI
 */

export type UserRole = 'STUDENT' | 'CLUB_ADMIN' | 'SUPER_ADMIN';

export const ROLES = {
  STUDENT: 'STUDENT' as const,
  CLUB_ADMIN: 'CLUB_ADMIN' as const,
  SUPER_ADMIN: 'SUPER_ADMIN' as const,
};

// Role to dashboard path mapping
export const ROLE_DASHBOARD_MAP: Record<UserRole, string> = {
  [ROLES.STUDENT]: '/dashboard/student',
  [ROLES.CLUB_ADMIN]: '/dashboard/club',
  [ROLES.SUPER_ADMIN]: '/dashboard/admin',
};

// Role display names
export const ROLE_DISPLAY_NAMES: Record<UserRole, string> = {
  [ROLES.STUDENT]: 'Student',
  [ROLES.CLUB_ADMIN]: 'Club Admin',
  [ROLES.SUPER_ADMIN]: 'Super Admin',
};

// Available roles for registration/login selection
export const AVAILABLE_ROLES_FOR_LOGIN = [
  { value: 'student', label: 'Student' },
  { value: 'club_admin', label: 'Club Admin' },
  { value: 'super_admin', label: 'Super Admin' },
] as const;

export const AVAILABLE_ROLES_FOR_REGISTER = [
  { value: 'student', label: 'Student' },
  { value: 'club_admin', label: 'Club Admin' },
] as const;

// Backend role naming convention (if different from frontend)
export const BACKEND_ROLE_MAP: Record<string, UserRole> = {
  'student': ROLES.STUDENT,
  'club_admin': ROLES.CLUB_ADMIN,
  'super_admin': ROLES.SUPER_ADMIN,
  'STUDENT': ROLES.STUDENT,
  'CLUB_ADMIN': ROLES.CLUB_ADMIN,
  'SUPER_ADMIN': ROLES.SUPER_ADMIN,
};
